import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useSelector } from 'react-redux';
import Moment from 'moment';
import ChartBarIcon from '../../../16pxIcons/ChartBarIcon';
import GymIcon40 from '../../../40pxIcons/GymIcon';
import MeetingRoomIcon40 from '../../../40pxIcons/MeetingRoomIcon';
import Colors from '../../../../constants/Colors';
import GetBookingsCount from '../../../../requests/Sensors/Occupancy/GetBookingsCount';
import { DateRange } from '../../../../redux/dateRangeSlice';
import { AreaType } from '../../../Map/SetFloorsModal/FloorItem';

interface RoomBookingsProps {
  locationId?: string,
}

const RoomBookings = ({ locationId }: RoomBookingsProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const [meetingRoomCount, setMeetingRoomCount] = useState<number | null>(null);
  const [gymCount, setGymCount] = useState<number | null>(null);

  useEffect(() => {
    if (!locationId) return;
    GetBookingsCount({
      locationId,
      locationSubtype: AreaType.GYM,
      from: range.selectedRange === 7 ? Moment().startOf('day').toISOString() : range.start,
      to: range.selectedRange === 7 ? Moment().endOf('day').toISOString() : range.end,
    }).then((res) => setGymCount(res));
    GetBookingsCount({
      locationId,
      locationSubtype: AreaType.MEETING_ROOM,
      from: range.selectedRange === 7 ? Moment().startOf('day').toISOString() : range.start,
      to: range.selectedRange === 7 ? Moment().endOf('day').toISOString() : range.end,
    }).then((res) => setMeetingRoomCount(res));
  }, []);

  return <View style={styles.container}>
    <View style={[styles.tile, styles.firstTile]}>
      <View style={styles.tileHeader}>
        <MeetingRoomIcon40 />
        <View style={styles.chartIconContainer}>
          <ChartBarIcon />
        </View>
      </View>
      <Text style={styles.label}>{'Meeting room bookings today'}</Text>
      <Text style={styles.count}>{meetingRoomCount ?? '-'}</Text>
    </View>
    <View style={[styles.tile, { flex: 1 }]}>
      <View style={styles.tileHeader}>
        <GymIcon40 />
        <View style={styles.chartIconContainer}>
          <ChartBarIcon />
        </View>
      </View>
      <Text style={styles.label}>{'Gym bookings today'}</Text>
      <Text style={styles.count}>{gymCount ?? '-'}</Text>
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'stretch',
  },
  tile: {
    flex: 1,
    marginTop: 16,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
    padding: 16,
    alignSelf: 'stretch',
  },
  firstTile: {
    marginTop: 0,
  },
  tileHeader: {
    marginBottom: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  chartIconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    padding: 4,
    backgroundColor: Colors.light.hereworksWhite200,
  },
  count: {
    fontSize: 30,
    lineHeight: 30,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_600SemiBold',
  },
  label: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 4,
  },
});

export default RoomBookings;
